export default __webpack_public_path__ + "static/media/mini2.020ae606.png";